import { FrameworkMilestone } from "services/aiRequirementsImport";

/**
 * Custom milestones replace the defaults entirely: a requirement named on the
 * Milestones sheet gets only its own rows, never a mix with the default set.
 */
export function milestonesForRequirement(
  milestones: FrameworkMilestone[],
  type: "epa" | "competency",
  code: string,
): FrameworkMilestone[] {
  const referencesForType = (milestone: FrameworkMilestone) =>
    type === "epa"
      ? (milestone.epa_codes || []).map((reference) =>
          reference.replace(/^EPA\s+/i, "").trim(),
        )
      : milestone.competency_codes || [];

  const custom = milestones.filter((milestone) =>
    referencesForType(milestone).some(
      (reference) => reference.toLowerCase() === code.toLowerCase(),
    ),
  );

  const selected =
    custom.length > 0
      ? custom
      : milestones.filter(
          (milestone) =>
            (milestone.epa_codes || []).length === 0 &&
            (milestone.competency_codes || []).length === 0,
        );

  return selected.slice().sort((a, b) => a.skill_level - b.skill_level);
}
